// widgetNames — the craft.js resolver key for each block type.
//
// These strings are NOT free-form labels: they must equal a key of the resolver
// object in src/pages/SegmentBuilder/Editor.jsx, because that key is what
// craft.js writes into a saved node's `resolvedName` and what it looks up again
// on deserialize. A value that is not a resolver key can never match a real
// node, so any comparison against it silently does nothing.
//
// Split out of segmentTools.js (which imports every CodeBlock, react-froala and
// its CSS) so this pure data — and its test — carry no render graph.
// Re-exported from segmentTools.js, so every existing import keeps working.
export const widgetNames = {
  TEXT: "TextWidget",
  CONTAINER: "ContainerWidget",
  DIVIDER: "DividerWidget",
  IMAGE: "ImageWidget",
  VIDEO: "VideoWidget",
  IMAGEWITHTEXT: "ImageWithText",
  IMAGEGRID: "ImageGridWidget",
  // measured on web-stg main.ab56523b.js 2026-08-01: a saved accordion reads
  // back as "Accordion", never "AccordionWidget"
  ACCORDION: "Accordion",
  // ...and a saved button block reads back as "Buttons"
  BUTTON: "Buttons",
  LINKWHEEL: "LinkWheelWidget",
  SOCIALLINKS: "SocialLinksWidget",
  DOCUMENT: "DocumentWidget",
  AUDIO: "AudioWidget",
  GRAPH: "GraphWidget",
  TABLE: "TableWidget",
  POLL: "PollWidget",
  // ...and a saved form reads back as "FormBlockWidget" (the CodeBlocks barrel
  // exports `Form as FormBlockWidget`, and that alias is the resolver key)
  FORM: "FormBlockWidget",
  CAROUSEL: "CarouselWidget",
  TITLE_BAR: "TitleBarWidget",
  EMPTY_CONTAINER: "EmptyContainerWidget",
};

export default widgetNames;
